import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { installWebMcp } from './lib/webmcp';

// Register on page load, independently of React rendering or user interaction.
let disposeWebMcp = () => {};
void installWebMcp().then((dispose) => { disposeWebMcp = dispose; }).catch((error) => {
  console.error('WebMCP tool registration failed:', error);
});
window.addEventListener('pagehide', (event) => {
  if (!event.persisted) disposeWebMcp();
});
if (import.meta.hot) import.meta.hot.dispose(() => disposeWebMcp());

const container = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// Every canonical route ships as static HTML (scripts/prerender.mjs), so the
// usual path is hydration. An empty root means this document is the bare shell
// the server falls back to, and there is nothing to hydrate.
if (container.firstChild) hydrateRoot(container, app);
else createRoot(container).render(app);
